import { createSelector } from "reselect";
import { type RootState } from "~/app/store";

const selectNavBreadcrumbsState = (state: RootState) => state.navigationBreadcrumbs.list;

export const selectNavigationBreadcrumbs = createSelector([selectNavBreadcrumbsState], (breadcrumbs) => breadcrumbs);
